import React, { useRef } from 'react';
import styles from './BasicInfo.module.css';

const BasicInfo = ({ userInfo, setUserInfo }) => {
  const fileInputRef = useRef(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUserInfo(prev => ({ ...prev, profileImage: URL.createObjectURL(file) }));
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.formSection}>
        <div className={styles.inputGroup}>
          <label className={styles.label}>Legal First Name</label>
          <input
            className={styles.input}
            name="legalFirstName"
            value={userInfo.legalFirstName}
            onChange={handleChange}
            placeholder="Legal First Name"
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>Preferred First Name</label>
          <input
            className={styles.input}
            name="preferredFirstName"
            value={userInfo.preferredFirstName}
            onChange={handleChange}
            placeholder="Preferred First Name"
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>Legal Last Name</label>
          <input
            className={styles.input}
            name="legalLastName"
            value={userInfo.legalLastName}
            onChange={handleChange}
            placeholder="Legal Last Name"
          />
        </div>
      </div>

      <div className={styles.pictureSection}>
        <div className={styles.picturePlaceholder} onClick={handleImageClick}>
          {userInfo.profileImage ? (
            <img src={userInfo.profileImage} alt="Profile" className={styles.profileImage} />
          ) : (
            <span className={styles.plusSign}>+</span>
          )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleImageChange}
            style={{ display: 'none' }}
            accept="image/*"
          />
        </div>

        {!userInfo.profileImage && (
          <span className={styles.addPictureText}>Add Picture</span>
        )}

        <span className={styles.userName}>
          {userInfo.preferredFirstName || "Your Name"}
        </span>
      </div>
    </div>
  );
};

export default BasicInfo;
